/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Timecodes_TextInputs */



/**
* | output |
* | --- |
* | "Was the Event Group created using a subtitle file with timecodes?" |
*
* @param {Event_Group_Timecodes_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_timecodes_text = /** @type {((inputs?: Event_Group_Timecodes_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Timecodes_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le groupe d’événements a-t-il été créé à partir d’un fichier de sous-titres avec codes temporels ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wurde die Ereignisgruppe mithilfe einer Untertiteldatei mit Zeitcodes erstellt?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il gruppo di eventi è stato creato utilizzando un file di sottotitoli con codici temporali?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Была ли группа событий создана с использованием файла субтитров с временными метками?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿El grupo de eventos se creó utilizando un archivo de subtítulos con códigos de tiempo?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件组是否使用带有时间码的字幕文件创建？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント グループは、タイムコード付きの字幕ファイルを使用して作成されましたか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या इवेंट ग्रुप को टाइमकोड वाली सबटाइटल फ़ाइल का उपयोग करके बनाया गया था?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O grupo de eventos foi criado usando um arquivo de legenda com códigos de tempo?")
	return /** @type {LocalizedString} */ ("Was the Event Group created using a subtitle file with timecodes?")
});